import { UseFormReturn } from "react-hook-form"
import { Form } from "../ui/form"

type Props = {
	children: React.ReactNode
	form: UseFormReturn<any>
	onSubmit?: VoidFunction
	className?: string
}

export function RHFProvider({ children, onSubmit, form, className }: Props) {
	return (
		<Form {...form}>
			<form onSubmit={onSubmit} className={className}>
				{children}
			</form>
		</Form>
	)
}
